export default {"src":"/_next/static/media/no_personal_data.350bb2ea.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};